module.exports = __webpack_public_path__ + "static/media/fileUseButton.16672daf.png";